import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  downloadInstallmentIncomeDetail,
  downloadExpensesSubProjectVoucherListFile,
  downloadIncomeSubProjectVoucherListFile,
} from '../../redux/actions/projectBasedItems'
import { sessionSetItemStr, sessionRemoveItem } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import SubProjectVoucherListTable from './SubProjectVoucherListTable'
import { searchSubprojectIncomExpensesList } from '../../redux/actions/accountingSubProject'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import SubProjectIncomeRecordInfo from '../subProjectIncomeRecordWidgets/SubProjectIncomeRecordInfo'
import { cloneDeep } from 'lodash-es'
import AccountingSubProjectPeriodWidget from '../panelHeder/AccountingSubProjectPeriodWidget'

export default function SubProjectVoucherListWidget(props) {
  const {} = props
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const history = useHistory()

  const subProjectCode = sessionStorage.getItem('subProjectCode')
  const subProjectPeriod = sessionGetItemObj('subProjectPeriod')
  const subProjectPeriodInfo = sessionGetItemObj('subProjectPeriodInfo')

  const handlePreview = async (fileObj) => {
    console.log('handlePreviewVoucher', fileObj)

    startLoading()
    setIsLoading(true)

    var file
    if (fileObj.type == 'Expense') {
      file = await downloadExpensesSubProjectVoucherListFile(fileObj.id)
      // console.log('Expense', fileObj.id)
    } else if (fileObj.type == 'Income') {
      file = await downloadIncomeSubProjectVoucherListFile(fileObj.id)
      // console.log('Income', fileObj.id)
    }

    // var file = await downloadInstallmentIncomeDetail(fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()

    setIsLoading(false)
    doneLoading()
  }

  const handleOnSearch = async (request, pageNum, pageSize) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await searchSubprojectIncomExpensesList(
        request,
        subProjectCode,
        subProjectPeriod,
        pageNum,
        pageSize
      )

      console.log('ressss -=> ', response)

      let _schema = cloneDeep(formSchema)
      _schema.datas = response.model
      setFormSchema(_schema)
    } catch (error) {
      console.log('error ', error)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelect = (rowData, type) => {
    // console.log('rowData ', type, rowData.type)
    // return false
    if (rowData?.type == 'Income' || type == 'Income') {
      // กรณีกดแก้ไขข้อมูล
      if (rowData) {
        sessionSetItemStr('subIncomeId', rowData.id)
      } else {
        sessionRemoveItem('subIncomeId')
      }

      history.push({
        pathname: pathname.incomeAndExpense.SubProjectIncomeRecord,
      })
    } else {
      // กรณีกดแก้ไขข้อมูล
      if (rowData) {
        sessionSetItemStr('subExpenseId', rowData.id)
      } else {
        sessionRemoveItem('subExpenseId')
      }
      history.push({
        pathname: pathname.incomeAndExpense.SubProjectExpenseRecord,
      })
    }
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={<AccountingSubProjectPeriodWidget subProjectPeriodInfo={subProjectPeriodInfo} />}
        bordered
      >
        {formSchema?.projectInfo && (
          <>
            <SubProjectIncomeRecordInfo schema={formSchema?.projectInfo} />
            <br />
          </>
        )}

        <SubProjectVoucherListTable
          schema={formSchema}
          loading={isLoading}
          onSelect={handleSelect}
          onSearch={handleOnSearch}
          onPreview={handlePreview}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
